import React, { useState } from 'react';
import { Row, Col, Spinner } from 'react-bootstrap';
import { MatchEntryAdmin } from '../../../models/interfaces/MatchEntry';
import { SportProvider } from '../../../models/interfaces/SportProvider';
import PlayerFormView from '../../teams/PlayerForm';

interface Props {
    sportProvider: SportProvider;
    matchEntryAdmin: MatchEntryAdmin;
}

const MatchEntryRosterRow = ({ sportProvider, matchEntryAdmin }: Props) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    return (
        <Row>
            <Col>
                {isSubmitting ? (
                    <Spinner animation="border" />
                ) : (
                    <PlayerFormView
                        sportProvider={sportProvider}
                        addingPlayer={isSubmitting}
                        handleSubmit={(
                            name,
                            capNumber,
                            position,
                            resetValues,
                            handleCancel,
                            handleError
                        ) => {
                            setIsSubmitting(true);
                            matchEntryAdmin
                                .addRosterEntry(name, capNumber, position)
                                .then(() => {
                                    resetValues();
                                })
                                .catch((error) => {
                                    handleError(error);
                                })
                                .finally(() => {
                                    setIsSubmitting(false);
                                });
                        }}
                        resetEditPlayer={() => {}}
                    />
                )}
            </Col>
        </Row>
    );
};

export default MatchEntryRosterRow;
